"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotDropzoneArea = void 0;
var core_1 = require("@material-ui/core");
var material_ui_dropzone_1 = require("material-ui-dropzone");
exports.TotDropzoneArea = core_1.withStyles(function (_a) {
    var palette = _a.palette;
    return ({
        dropZone: {
            minHeight: 'unset',
            outlineColor: palette.primary.main,
        },
    });
})(material_ui_dropzone_1.DropzoneArea);
